import type { FilterState, TenderType, Voivodeship } from '../types/filters';

interface FilterPanelProps {
  filters: FilterState;
  onVoivodeshipChange: (value: Voivodeship | null) => void;
  onTenderTypeChange: (value: TenderType | null) => void;
  onPriceRangeChange: (min: number | null, max: number | null) => void;
  onReset: () => void;
}

const VOIVODESHIPS: { value: Voivodeship; label: string }[] = [
  { value: 'zachodniopomorskie', label: 'Zachodniopomorskie' },
  { value: 'lubuskie', label: 'Lubuskie' },
];

const TENDER_TYPES: { value: TenderType; label: string }[] = [
  { value: 'sale', label: 'Sprzedaż' },
  { value: 'lease', label: 'Dzierżawa' },
  { value: 'auction', label: 'Przetarg' },
  { value: 'other', label: 'Inne' },
];

export function FilterPanel({
  filters,
  onVoivodeshipChange,
  onTenderTypeChange,
  onPriceRangeChange,
  onReset,
}: FilterPanelProps) {
  const hasActiveFilters =
    filters.voivodeship !== null ||
    filters.tender_type !== null ||
    filters.min_price !== null ||
    filters.max_price !== null;

  return (
    <div className="filter-panel">
      <h2>Filtry</h2>

      <div className="filter-group">
        <label htmlFor="voivodeship">Województwo</label>
        <select
          id="voivodeship"
          value={filters.voivodeship || ''}
          onChange={(e) =>
            onVoivodeshipChange((e.target.value as Voivodeship) || null)
          }
        >
          <option value="">Wszystkie</option>
          {VOIVODESHIPS.map((v) => (
            <option key={v.value} value={v.value}>
              {v.label}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label htmlFor="tender_type">Typ przetargu</label>
        <select
          id="tender_type"
          value={filters.tender_type || ''}
          onChange={(e) =>
            onTenderTypeChange((e.target.value as TenderType) || null)
          }
        >
          <option value="">Wszystkie</option>
          {TENDER_TYPES.map((t) => (
            <option key={t.value} value={t.value}>
              {t.label}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label>Cena (PLN)</label>
        <div className="price-range">
          <input
            type="number"
            placeholder="Min"
            value={filters.min_price ?? ''}
            onChange={(e) =>
              onPriceRangeChange(
                e.target.value ? Number(e.target.value) : null,
                filters.max_price
              )
            }
            min={0}
          />
          <span>—</span>
          <input
            type="number"
            placeholder="Max"
            value={filters.max_price ?? ''}
            onChange={(e) =>
              onPriceRangeChange(
                filters.min_price,
                e.target.value ? Number(e.target.value) : null
              )
            }
            min={0}
          />
        </div>
      </div>

      {hasActiveFilters && (
        <button className="reset-button" onClick={onReset}>
          Resetuj filtry
        </button>
      )}
    </div>
  );
}
